export default __webpack_public_path__ + "static/media/superballs.9ccca808.png";